import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';
import { mapTruthy } from '~/util/array';
import { isString } from '~/util/string';

type FieldError = {
  message?: any;
};

export interface UseFormFieldErrorTranslationResult {
  errorToHelperText: (
    error: FieldError | FieldError[] | Record<string, FieldError>[] | undefined,
  ) => string | undefined;
}

export const useFormFieldErrorTranslation = (): UseFormFieldErrorTranslationResult => {
  const { t } = useTranslation(I18nNamespace.validation);
  return useMemo(() => {
    return {
      errorToHelperText: (error) => {
        if (error) {
          const errList = Array.isArray(error) ? error : [error];
          return mapTruthy((err: FieldError) => {
            if (err.message) {
              if (isString(err.message)) {
                return t(err.message);
              } else {
                return t(err.message.key, err.message.values);
              }
            }
          })(errList).join(', ');
        }
        return undefined;
      },
    };
  }, [t]);
};
